module.exports = __webpack_public_path__ + "static/media/information-icon-white-6.49573299.jpg";